import React from 'react';

import { ComponentProps } from '../../typings/generic-component';
import { makeClassNames, IClassNames } from '../../utils/styles';
import './banner-no-cookies.scss';
import IconAlert from '../icons/icon-alert';
import t from '../../labels/labelling-utils';
import { SocialType } from '../../typings/common-types';

export interface IBannerNoCookies extends ComponentProps {
  socialType?: SocialType;
}

const classNames = (): IClassNames =>
  makeClassNames({
    BannerNoCookies: 'banner-no-cookies',
    BnCContent: 'banner-no-cookies__content',
    BnCIcon: 'banner-no-cookies__icon',
    BnCSubtitle: 'banner-no-cookies__subtitle',
    BnCButton: 'banner-no-cookies__button',
    BnCButtonText: 'banner-no-cookies__button-text',
  });

const handleClick = () => {
  // @ts-ignore
  window._sp_.loadPrivacyManagerModal(window.SkyFoundationSettings.cmpPrivacyManagerId);
};

const BannerNoCookies: React.FC<IBannerNoCookies> = ({ socialType }) => {
  const cn = classNames();
  const socialLabel = socialType ? t(`social.embed.${socialType}.label`) : '';

  return (
    <div className={cn.BannerNoCookies}>
      <div className={cn.BnCContent}>
        <IconAlert className={cn.BnCIcon} height={42} width={42} />
        <h6>{t('banner-no-cookies.title')}</h6>
        <div className={cn.BnCSubtitle}>
          {t('banner-no-cookies.subtitle.1')} <b>{socialLabel}</b>
          {t('banner-no-cookies.subtitle.2')}
        </div>
        <button type="submit" className={cn.BnCButton} onClick={handleClick}>
          {t('banner-no-cookies.button.label')}
        </button>
      </div>
    </div>
  );
};

export default BannerNoCookies;
